import React from "react"
import { Field } from "react-final-form"
import Config from "Data"

export default props => {
  const { hiddenData } = props
  // console.log('hiddenData: ', hiddenData);
  // hiddenData.formName = 'FormSponsor';
  // hiddenData.origin = windowGlobal ? windowGlobal.location.href : '';
  // hiddenData.retURL = '/sponsor-thank-you';
  // hiddenData.country = windowGlobal.country;
  // hiddenData.brand = Config.brand;
  // hiddenData.mailingList = 'sponsor_cxosync';
  return (
    <>
      <Field name="formName" type="hidden" component="input" />
      <Field name="origin" type="hidden" component="input" value={hiddenData ? hiddenData.origin : ""} />
      <Field name="retURL" type="hidden" component="input" />
      <Field name="country" type="hidden" component="input" value={hiddenData ? hiddenData.country : ""} />
      <Field name="marketing_code" type="hidden" component="input" />
      <Field name="incentive" type="hidden" component="input" />
    </>
  )
}
